/* eslint-disable no-nested-ternary */

"use client"

import clsx from "clsx"

import PageGrid from "@/ui/components/PageGrid"
import type { CarouselVideos } from "@/ui/components/VideoCarousel"
import VideoCarousel from "@/ui/components/VideoCarousel"

interface videoCarouselProps
  extends CarouselVideos,
    React.ComponentPropsWithoutRef<"div"> {
  videos: any
  sectionTitle?: string
  pencilDescription?: string
  subDescription?: string
  darkmode?: boolean
}

const VideoCarouselProvider: React.FC<videoCarouselProps> = ({
  videos,
  sectionTitle,
  pencilDescription,
  subDescription,
  darkmode,
  className,
}) => (
  <section className={clsx("py-16 md:py-20 lg:py-22 xl:py-28", className)}>
    <PageGrid>
      <div className="w-full col-span-full">
        <VideoCarousel
          videos={videos}
          sectionTitle={sectionTitle}
          pencilDescription={pencilDescription}
          darkmode={darkmode}
          subDescription={subDescription}
        />
      </div>
    </PageGrid>
  </section>
)

export default VideoCarouselProvider
